'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["ownerState", "slots", "slotProps"];
import * as React from 'react';
import useSlotProps from '@mui/utils/useSlotProps';
import { useMessageContext } from "./internals/MessageContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
function getAuthorLabel(ownerState) {
  return ownerState.resolvedAuthor?.displayName ?? null;
}
export const MessageAuthorLabel = /*#__PURE__*/React.forwardRef(function MessageAuthorLabel(props, ref) {
  const _ref = props,
    {
      ownerState: ownerStateProp,
      slots,
      slotProps
    } = _ref,
    other = _objectWithoutPropertiesLoose(_ref, _excluded);
  void ownerStateProp;
  const ownerState = useMessageContext();
  const AuthorLabel = slots?.authorLabel ?? 'span';
  const authorLabelProps = useSlotProps({
    elementType: AuthorLabel,
    externalSlotProps: slotProps?.authorLabel,
    externalForwardedProps: other,
    ownerState,
    additionalProps: {
      ref
    }
  });

  // Only render in compact variant and when this is the first message in a group
  if (ownerState.variant !== 'compact' || ownerState.isGrouped) {
    return null;
  }
  const authorLabel = getAuthorLabel(ownerState);
  if (!authorLabel) {
    return null;
  }
  return /*#__PURE__*/_jsx(AuthorLabel, _extends({}, authorLabelProps, {
    children: authorLabel
  }));
});
if (process.env.NODE_ENV !== "production") MessageAuthorLabel.displayName = "MessageAuthorLabel";